// const linker = '/acm-ioit-react/';
const linker = '/';

export default linker;
